import { Component, HostBinding, HostListener, OnDestroy, OnInit } from '@angular/core';
import { GMDnavItmes } from '../../models/nav-itemes';
import { AccountsLoginService } from '../../services/accounts-login-service';
import { UtilityService } from '../../services/utility-service';
import { LoginService } from 'src/app/services/login-service';
import { NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';

interface GMDnavItems {
  name: string;
  path?: string;
  icons: string;
  children?: GMDnavItems[];
}

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent implements OnInit, OnDestroy {
  public expandedPath: string | null = null;
  public sessionStorage: Storage = sessionStorage;
  public navItems: GMDnavItems[];
  public l_userAuthenticated: boolean = false;
  public fullName: string = '';
  public clientName: string = '';
  private loginStatusSubscription;
  public l_financialYear: string = '';
  public showSideMenu: boolean;
  public router: any;
  public expandedIndexes = new Set<number>();
  public expandedSubIndexes = new Set<string>();
  public sideNavOpen = true;
  public settingsOpen = false;
  public isTestEnvironment: boolean = false;

  constructor(    
    private l_accountsLoginService: AccountsLoginService,
    private l_UtilityService: UtilityService,
    private l_loginService: LoginService
  ) {}

ngOnInit(): void {
  this.isTestEnvironment = environment.ROOT_URL.toLowerCase().includes('test');

  this.loginStatusSubscription =
    this.l_accountsLoginService.loginStatus$.subscribe((status: boolean) => {
      this.l_userAuthenticated = status;

      if (status) {
        this.lFN_SetNavMenuAccessControl();
        this.fullName = sessionStorage.getItem('full_name') || '';
        const clientMaster = JSON.parse(sessionStorage.getItem('client_master'));
        this.clientName = clientMaster.clientName;
      } else {
        this.navItems = [];
        this.fullName = '';
      }
    });

  if (window.innerWidth < 768) {
    this.sideNavOpen = false;
  }
}

toggleMenu(i:number){
  this.expandedIndexes.has(i)
    ? this.expandedIndexes.delete(i)
    : this.expandedIndexes.add(i);
}

toggleSubMenu(i:number,j:number){
  const key = i + '-' + j;
  this.expandedSubIndexes.has(key)
    ? this.expandedSubIndexes.delete(key)
    : this.expandedSubIndexes.add(key);
}



ngOnDestroy(): void {
  // Unsubscribe to prevent memory leaks
  if (this.loginStatusSubscription) {
    this.loginStatusSubscription.unsubscribe();
  }
}

lFN_OpenChildren(index: number, event: Event) {
  event.preventDefault();
  this.expandedIndexes.has(index)
    ? this.expandedIndexes.delete(index)
    : this.expandedIndexes.add(index);
}

lFN_OpenSubChildren(parentIndex: number, childIndex: number, event: Event) {
  event.preventDefault();
  const key = `${parentIndex}-${childIndex}`;

  this.expandedSubIndexes.has(key)
    ? this.expandedSubIndexes.delete(key)
    : this.expandedSubIndexes.add(key);
}

openAllMenus(): void {
  this.navItems.forEach((menu, i) => {
    // open top-level menu
    if (menu.children?.length) {
      this.expandedIndexes.add(i);

      // open all second-level menus
      menu.children.forEach((child, j) => {
        if (child.children?.length) {
          this.expandedSubIndexes.add(`${i}-${j}`);
        }
      });
    }
  });
}

lFN_LogoutUser() {
  this.l_UtilityService.lFN_ShowLoader();

  setTimeout(() => {
    // ✅ Clear session storage
    sessionStorage.removeItem('auth_token');
    sessionStorage.removeItem('user_id');
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('full_name');
    sessionStorage.removeItem('role');
    sessionStorage.removeItem('client_master');

    // OR if you want to clear everything
    // sessionStorage.clear();

    this.l_userAuthenticated = false;
    this.fullName = '';
    this.settingsOpen = false;
    this.l_UtilityService.lFN_HideLoader();
    this.l_UtilityService.lFN_Navigate('login', 'create');
  }, 300);
}


lFN_SetNavMenuAccessControl() {
  const menuData = sessionStorage.getItem('menu_nav_items');
  this.navItems = menuData ? JSON.parse(menuData) : [];
  this.openAllMenus();
  //console.log("Nav items ==>"+ this.navItems);
}


}
